import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import { Timer } from "../../Timer";

export const HeadVoting = ({ maxVote, voted, timeLeft, availableVoices, voterTotalCount, voterVotedCount, setTimeIsUp }) => {

    return (
        <div className = 'head-voting' >
            <div className = 'm-width head-voting__child'>
                <div className = 'head-voting__left'>
                    <div className = 'head-voting__info'>
                        <div className = { `head-voting__count-wrap ${availableVoices===maxVote ? 'head-voting__count-wrap--done' : ''}` }>
                            <div className = 'head-voting__count-icon'><i className = { `icon icon-check` } /></div>
                            <div className = 'head-voting__count-text'><span>{availableVoices} / {maxVote}</span></div>
                        </div>
                        <h2 className = 'head-voting__info-title' >Ви можете проголосувати за двох кандидатів</h2>
                    </div>
                    <p className = 'head-voting__prompt'>У вас є два голоси для голосування</p>
                </div>
                <div className = 'head-voting__right'>
                    <span className = 'head-voting__prompt'>
                        До кінця голосування залишилося
                    </span>
                    <div className = 'head-voting__timer'>
                        <Timer setTimeIsUp = { setTimeIsUp } unixTime = { timeLeft } />
                    </div>
                    <span className = 'head-voting__all-counter'>
                        Проголосували <span>{voterVotedCount+voted}</span> із <span>{voterTotalCount}</span> осіб
                    </span>
                </div>
            </div>
        </div>
    );
};

HeadVoting.propTypes = {
    availableVoices: PropTypes.number.isRequired,
    maxVote:         PropTypes.number.isRequired,
    timeLeft:        PropTypes.number.isRequired,
    voted:           PropTypes.number.isRequired,
    voterTotalCount: PropTypes.number.isRequired,
    voterVotedCount: PropTypes.number.isRequired,
    setTimeIsUp:     PropTypes.func.isRequired,

};
